import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, normalizeClass as _normalizeClass, vModelSelect as _vModelSelect, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "page-wrap" }
const _hoisted_2 = { class: "page-bar" }
const _hoisted_3 = { class: "page-bar-main" }
const _hoisted_4 = {
  key: 0,
  class: "page-bar-owner"
}
const _hoisted_5 = {
  style: {"display":"flex","align-items":"center"},
  class: "hide-mobile-991"
}
const _hoisted_6 = {
  key: 0,
  class: "btn-row"
}
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = {
  key: 1,
  class: "btn-row"
}
const _hoisted_10 = ["onClick"]
const _hoisted_11 = { class: "emp-grid" }
const _hoisted_12 = { class: "emp-grid-main" }
const _hoisted_13 = { class: "panel" }
const _hoisted_14 = { class: "emp-h4" }
const _hoisted_15 = { class: "emp-record-grid" }
const _hoisted_16 = { class: "emp-field-value" }
const _hoisted_17 = { class: "emp-field-value" }
const _hoisted_18 = ["href"]
const _hoisted_19 = { key: 1 }
const _hoisted_20 = { class: "emp-field-value" }
const _hoisted_21 = ["href"]
const _hoisted_22 = { key: 1 }
const _hoisted_23 = { class: "emp-field-value" }
const _hoisted_24 = { class: "emp-field-value" }
const _hoisted_25 = { key: 0 }
const _hoisted_26 = { class: "emp-field-value" }
const _hoisted_27 = { class: "emp-field-value" }
const _hoisted_28 = { class: "emp-field-value" }
const _hoisted_29 = { class: "emp-field-label" }
const _hoisted_30 = {
  key: 0,
  class: "emp-field-value"
}
const _hoisted_31 = ["onClick"]
const _hoisted_32 = { key: 1 }
const _hoisted_33 = {
  key: 1,
  class: "emp-field-value"
}
const _hoisted_34 = {
  key: 0,
  class: "emp-record-grid",
  style: {"margin-top":"15px"}
}
const _hoisted_35 = ["innerHTML"]
const _hoisted_36 = { class: "emp-field-value" }
const _hoisted_37 = { class: "panel" }
const _hoisted_38 = { class: "emp-h4" }
const _hoisted_39 = { key: 1 }
const _hoisted_40 = {
  key: 0,
  class: "emp-acc-list"
}
const _hoisted_41 = {
  key: 0,
  style: {"font-weight":"normal"}
}
const _hoisted_42 = {
  key: 1,
  class: "emp-empty"
}
const _hoisted_43 = {
  key: 2,
  class: "emp-empty"
}
const _hoisted_44 = {
  key: 2,
  class: "panel"
}
const _hoisted_45 = {
  key: 0,
  class: "emp-empty"
}
const _hoisted_46 = {
  key: 1,
  class: "emp-empty"
}
const _hoisted_47 = { class: "emp-signoff-main" }
const _hoisted_48 = { class: "emp-review-by" }
const _hoisted_49 = { class: "panel" }
const _hoisted_50 = { class: "emp-h4" }
const _hoisted_51 = {
  key: 0,
  class: "emp-empty"
}
const _hoisted_52 = ["onClick"]
const _hoisted_53 = { style: {"display":"flex","justify-content":"space-between","align-items":"flex-start","gap":"10px"} }
const _hoisted_54 = { class: "emp-review-date" }
const _hoisted_55 = { class: "emp-review-by" }
const _hoisted_56 = { class: "emp-field-label" }
const _hoisted_57 = ["innerHTML"]
const _hoisted_58 = ["innerHTML"]
const _hoisted_59 = { class: "emp-grid-side" }
const _hoisted_60 = { class: "panel emp-profile-card" }
const _hoisted_61 = { class: "av emp-profile-av" }
const _hoisted_62 = { class: "emp-profile-name" }
const _hoisted_63 = {
  key: 0,
  class: "emp-profile-role"
}
const _hoisted_64 = {
  key: 0,
  class: "panel emp-accounts"
}
const _hoisted_65 = { class: "emp-h4" }
const _hoisted_66 = { class: "emp-accounts-row" }
const _hoisted_67 = {
  key: 0,
  class: "emp-field-value"
}
const _hoisted_68 = { class: "emp-accounts-sub" }
const _hoisted_69 = {
  key: 1,
  class: "emp-empty"
}
const _hoisted_70 = { class: "emp-accounts-row" }
const _hoisted_71 = {
  key: 0,
  class: "emp-field-value"
}
const _hoisted_72 = { class: "emp-accounts-sub" }
const _hoisted_73 = {
  key: 1,
  class: "emp-empty"
}
const _hoisted_74 = {
  key: 0,
  class: "emp-accounts-hint",
  style: {"margin":"0"}
}
const _hoisted_75 = { class: "emp-accounts-row" }
const _hoisted_76 = ["value"]
const _hoisted_77 = { class: "emp-accounts-row" }
const _hoisted_78 = ["value"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_employee_tag_panel = _resolveComponent("employee-tag-panel")!
  const _component_pdf_pop_up = _resolveComponent("pdf-pop-up")!
  const _component_team_hub_role_col = _resolveComponent("team-hub-role-col")!
  const _component_add_edit_employee = _resolveComponent("add-edit-employee")!
  const _component_add_employee_review = _resolveComponent("add-employee-review")!
  const _component_edit_employee_checklists = _resolveComponent("edit-employee-checklists")!
  const _component_edit_employee_role = _resolveComponent("edit-employee-role")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", null, [
        _cache[20] || (_cache[20] = _createElementVNode("div", { class: "page-bar-sub" }, "Team / Employees", -1)),
        _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.formData.Name), 1),
        (_ctx.formData.SeatTitle)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(_ctx.formData.SeatTitle), 1))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", {
          class: "btn-light",
          style: {"margin-right":"15px"},
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.back()))
        }, "Back")
      ])
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(_ctx.$store.state.routeLoaded ? 'slide-up view' : 'hide')
    }, [
      (_ctx.$store.state.user.teamHubRole == 'Admin' || _ctx.formData.ReportingTo == _ctx.$store.state.user.teamHubEmployee?.ID)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createElementVNode("div", {
              class: "btn",
              onClick: _cache[1] || (_cache[1] = () => { _ctx.showReview = true })
            }, "Start review"),
            _createElementVNode("div", {
              class: "btn-light",
              onClick: _cache[2] || (_cache[2] = () => { _ctx.showAddEdit = true })
            }, "Edit record"),
            _createElementVNode("div", {
              class: "btn-light",
              onClick: _cache[3] || (_cache[3] = () => { _ctx.showEditRole = true })
            }, [
              (_ctx.rawEmployee.RoleSheetSlug)
                ? (_openBlock(), _createElementBlock("span", _hoisted_7, "Update"))
                : (_openBlock(), _createElementBlock("span", _hoisted_8, "Assign")),
              _cache[21] || (_cache[21] = _createTextVNode(" Role", -1))
            ]),
            _createElementVNode("div", {
              class: "btn-light",
              onClick: _cache[4] || (_cache[4] = () => { _ctx.showEditChecklists = true })
            }, "Assign Checklists")
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_9, [
            (_ctx.rawEmployee.RoleSheetSlug)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: "btn",
                  onClick: _cache[5] || (_cache[5] = () => { _ctx.showViewRole = true })
                }, "View Role"))
              : _createCommentVNode("", true),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.checklists, (c, i) => {
              return (_openBlock(), _createElementBlock("div", {
                key: i,
                class: "btn-light",
                onClick: () => { _ctx.checklistSlugToView = c.Slug; _ctx.showChecklist = true; }
              }, _toDisplayString(c.Name), 9, _hoisted_10))
            }), 128))
          ])),
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("h4", _hoisted_14, [
              _cache[22] || (_cache[22] = _createTextVNode("Record", -1)),
              (_ctx.$store.state.user.teamHubRole == 'Admin')
                ? (_openBlock(), _createElementBlock("span", {
                    key: 0,
                    class: "panel-link",
                    onClick: _cache[6] || (_cache[6] = () => { _ctx.showAddEdit = true })
                  }, "Edit Record"))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("div", null, [
                _cache[23] || (_cache[23] = _createElementVNode("div", { class: "emp-field-label" }, "Name", -1)),
                _createElementVNode("div", _hoisted_16, _toDisplayString(_ctx.formData.Name || '—'), 1)
              ]),
              _createElementVNode("div", null, [
                _cache[24] || (_cache[24] = _createElementVNode("div", { class: "emp-field-label" }, "Email", -1)),
                _createElementVNode("div", _hoisted_17, [
                  (_ctx.formData.Email)
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 0,
                        href: 'mailto:'+_ctx.formData.Email
                      }, _toDisplayString(_ctx.formData.Email), 9, _hoisted_18))
                    : (_openBlock(), _createElementBlock("span", _hoisted_19, "—"))
                ])
              ]),
              _createElementVNode("div", null, [
                _cache[25] || (_cache[25] = _createElementVNode("div", { class: "emp-field-label" }, "Phone", -1)),
                _createElementVNode("div", _hoisted_20, [
                  (_ctx.formData.Phone)
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 0,
                        href: 'tel:'+_ctx.formData.Phone
                      }, _toDisplayString(_ctx.formatPhone(_ctx.formData.Phone)), 9, _hoisted_21))
                    : (_openBlock(), _createElementBlock("span", _hoisted_22, "—"))
                ])
              ]),
              _createElementVNode("div", null, [
                _cache[26] || (_cache[26] = _createElementVNode("div", { class: "emp-field-label" }, "Title", -1)),
                _createElementVNode("div", _hoisted_23, _toDisplayString(_ctx.formData.SeatTitle || '—'), 1)
              ]),
              _createElementVNode("div", null, [
                _cache[27] || (_cache[27] = _createElementVNode("div", { class: "emp-field-label" }, "Team", -1)),
                _createElementVNode("div", _hoisted_24, _toDisplayString(_ctx.formData.Team || '—'), 1)
              ]),
              (_ctx.additionalTeams.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                    _cache[28] || (_cache[28] = _createElementVNode("div", { class: "emp-field-label" }, "Additional Teams", -1)),
                    _createElementVNode("div", _hoisted_26, _toDisplayString(_ctx.additionalTeams.join(', ')), 1)
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", null, [
                _cache[29] || (_cache[29] = _createElementVNode("div", { class: "emp-field-label" }, "Location", -1)),
                _createElementVNode("div", _hoisted_27, _toDisplayString(_ctx.formData.Location || '—'), 1)
              ]),
              _createElementVNode("div", null, [
                _cache[30] || (_cache[30] = _createElementVNode("div", { class: "emp-field-label" }, "Reporting To", -1)),
                _createElementVNode("div", _hoisted_28, _toDisplayString(_ctx.formData.ReportingToName || '—'), 1)
              ]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.formData.AdditionalFieldsJSON, (f, i) => {
                return (_openBlock(), _createElementBlock("div", { key: i }, [
                  _createElementVNode("div", _hoisted_29, _toDisplayString(f.name), 1),
                  (f.secure)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                        (f.value)
                          ? (_openBlock(), _createElementBlock("a", {
                              key: 0,
                              onClick: _withModifiers(($event: any) => (_ctx.getSecureField(f)), ["prevent"])
                            }, "View", 8, _hoisted_31))
                          : (_openBlock(), _createElementBlock("span", _hoisted_32, "--"))
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_33, _toDisplayString(f.value || '—'), 1))
                ]))
              }), 128))
            ]),
            (_ctx.formData.Status == 'Terminated')
              ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                  _createElementVNode("div", null, [
                    _cache[31] || (_cache[31] = _createElementVNode("div", { class: "emp-field-label" }, "Termination Details", -1)),
                    _createElementVNode("div", {
                      class: "emp-field-value",
                      innerHTML: _ctx.formData.TerminationDetailsHTML || '—'
                    }, null, 8, _hoisted_35)
                  ]),
                  _createElementVNode("div", null, [
                    _cache[32] || (_cache[32] = _createElementVNode("div", { class: "emp-field-label" }, "Termination Date", -1)),
                    _createElementVNode("div", _hoisted_36, _toDisplayString(_ctx.formData.TerminationDate || '—'), 1)
                  ])
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_37, [
            _createElementVNode("h4", _hoisted_38, [
              _cache[34] || (_cache[34] = _createTextVNode("Accountabilities", -1)),
              _createElementVNode("span", null, [
                (_ctx.rawEmployee.RoleSheetSlug)
                  ? (_openBlock(), _createElementBlock("a", {
                      key: 0,
                      onClick: _cache[7] || (_cache[7] = _withModifiers(() => { _ctx.showViewRole = true }, ["prevent"])),
                      class: "panel-link"
                    }, "View Role"))
                  : _createCommentVNode("", true),
                (_ctx.$store.state.user.teamHubRole == 'Admin' && _ctx.rawEmployee.RoleSheetSlug)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_39, " | "))
                  : _createCommentVNode("", true),
                (_ctx.$store.state.user.teamHubRole == 'Admin' && _ctx.rawEmployee.RoleSheetSlug)
                  ? (_openBlock(), _createBlock(_component_router_link, {
                      key: 2,
                      to: '/edit-sheet/'+_ctx.rawEmployee.RoleSheetSlug,
                      class: "panel-link"
                    }, {
                      default: _withCtx(() => [...(_cache[33] || (_cache[33] = [
                        _createTextVNode("Set in Role Sheet", -1)
                      ]))]),
                      _: 1
                    }, 8, ["to"]))
                  : _createCommentVNode("", true)
              ])
            ]),
            (_ctx.accountabilities.length)
              ? (_openBlock(), _createElementBlock("ol", _hoisted_40, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.accountabilities, (a, i) => {
                    return (_openBlock(), _createElementBlock("li", { key: i }, [
                      _createTextVNode(_toDisplayString(a.value), 1),
                      (a.value2)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_41, " — " + _toDisplayString(a.value2), 1))
                        : _createCommentVNode("", true)
                    ]))
                  }), 128))
                ]))
              : (!_ctx.rawEmployee.RoleSheetSlug)
                ? (_openBlock(), _createElementBlock("div", _hoisted_42, "Employee has not been assigned a role."))
                : (_openBlock(), _createElementBlock("div", _hoisted_43, "Nothing added yet."))
          ]),
          (_ctx.formData.ID)
            ? (_openBlock(), _createBlock(_component_employee_tag_panel, {
                key: 0,
                label: "What I Value in Life",
                endpoint: "valuesinlife",
                "employee-id": _ctx.formData.ID,
                items: _ctx.formData.ValuesInLifeJSON
              }, null, 8, ["employee-id", "items"]))
            : _createCommentVNode("", true),
          (_ctx.formData.ID)
            ? (_openBlock(), _createBlock(_component_employee_tag_panel, {
                key: 1,
                label: "What I Enjoy Doing",
                endpoint: "enjoysdoing",
                "employee-id": _ctx.formData.ID,
                items: _ctx.formData.EnjoysDoingJSON
              }, null, 8, ["employee-id", "items"]))
            : _createCommentVNode("", true),
          (_ctx.signOffsLoaded)
            ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
                _cache[35] || (_cache[35] = _createElementVNode("h4", { class: "emp-h4" }, "Sign-offs", -1)),
                (!_ctx.hasStandardUser)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_45, "No standard user is linked to this employee, so there's nothing to sign."))
                  : (!_ctx.signOffs.length)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_46, "Nothing signed yet."))
                    : _createCommentVNode("", true),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.visibleSignOffs, (s) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: s.Slug,
                    class: "emp-signoff"
                  }, [
                    _createElementVNode("div", _hoisted_47, [
                      _createVNode(_component_router_link, {
                        to: '/playbook/' + s.Slug,
                        class: "emp-signoff-name"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(s.Name), 1)
                        ]),
                        _: 2
                      }, 1032, ["to"]),
                      _createElementVNode("div", _hoisted_48, _toDisplayString(_ctx.$store.state.playbookNodeTypeMap[s.Type]) + " · signed " + _toDisplayString(s.DateDisplay), 1)
                    ]),
                    _createElementVNode("span", {
                      class: _normalizeClass(["pill", s.Current ? 'p-done' : 'p-live'])
                    }, _toDisplayString(s.Current ? 'Current v' + s.Version : 'Needs to sign again'), 3)
                  ]))
                }), 128)),
                (_ctx.signOffs.length > 6)
                  ? (_openBlock(), _createElementBlock("a", {
                      key: 2,
                      class: "panel-link emp-signoff-more",
                      onClick: _cache[8] || (_cache[8] = _withModifiers(($event: any) => (_ctx.showAllSignOffs = !_ctx.showAllSignOffs), ["prevent"]))
                    }, _toDisplayString(_ctx.showAllSignOffs ? 'Show less' : 'Show all ' + _ctx.signOffs.length), 1))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_49, [
            _createElementVNode("h4", _hoisted_50, [
              _cache[36] || (_cache[36] = _createTextVNode("Review History", -1)),
              (_ctx.$store.state.user.teamHubRole == 'Admin')
                ? (_openBlock(), _createElementBlock("span", {
                    key: 0,
                    class: "panel-link",
                    onClick: _cache[9] || (_cache[9] = () => { _ctx.showReview = true })
                  }, "Add review"))
                : _createCommentVNode("", true)
            ]),
            (!_ctx.reviews.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_51, "No reviews yet."))
              : _createCommentVNode("", true),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.reviews, (r, i) => {
              return (_openBlock(), _createElementBlock("div", {
                key: i,
                class: "emp-review-card",
                onClick: () => { r.expanded = !r.expanded }
              }, [
                _createElementVNode("div", _hoisted_53, [
                  _createElementVNode("div", null, [
                    _createElementVNode("div", _hoisted_54, _toDisplayString(r.DateDisplay), 1),
                    _createElementVNode("div", _hoisted_55, "Reviewed by " + _toDisplayString(r.UserName), 1)
                  ]),
                  _cache[37] || (_cache[37] = _createElementVNode("span", { class: "pill p-done" }, "Completed", -1))
                ]),
                (r.expanded)
                  ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(r.Fields, (f, j) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: j,
                        style: {"margin-top":"10px"}
                      }, [
                        _createElementVNode("div", _hoisted_56, _toDisplayString(f.name), 1),
                        _createElementVNode("div", {
                          innerHTML: f.value
                        }, null, 8, _hoisted_57)
                      ]))
                    }), 128))
                  : (r.Fields.length)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 1,
                        style: {"margin-top":"10px"},
                        innerHTML: r.Fields[0].value
                      }, null, 8, _hoisted_58))
                    : _createCommentVNode("", true)
              ], 8, _hoisted_52))
            }), 128))
          ])
        ]),
        _createElementVNode("div", _hoisted_59, [
          _createElementVNode("div", _hoisted_60, [
            _createElementVNode("div", _hoisted_61, _toDisplayString(_ctx.initials), 1),
            _createElementVNode("div", _hoisted_62, _toDisplayString(_ctx.formData.Name), 1),
            (_ctx.formData.SeatTitle)
              ? (_openBlock(), _createElementBlock("div", _hoisted_63, _toDisplayString(_ctx.formData.SeatTitle), 1))
              : _createCommentVNode("", true),
            _createElementVNode("span", {
              class: _normalizeClass(["pill", _ctx.formData.Status == 'Terminated' ? 'p-live' : 'p-done'])
            }, _toDisplayString(_ctx.formData.Status), 3)
          ]),
          (_ctx.accounts)
            ? (_openBlock(), _createElementBlock("div", _hoisted_64, [
                _createElementVNode("h4", _hoisted_65, [
                  _cache[38] || (_cache[38] = _createTextVNode("Sign-in accounts", -1)),
                  _createElementVNode("span", {
                    class: "panel-link",
                    onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.toggleEditAccounts()))
                  }, _toDisplayString(_ctx.editingAccounts ? 'Cancel' : 'Change'), 1)
                ]),
                (!_ctx.editingAccounts)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createElementVNode("div", _hoisted_66, [
                        _cache[39] || (_cache[39] = _createElementVNode("div", { class: "emp-field-label" }, "Admin account", -1)),
                        (_ctx.accounts.adminUser)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_67, [
                              _createTextVNode(_toDisplayString(_ctx.accounts.adminUser.FirstName) + " " + _toDisplayString(_ctx.accounts.adminUser.LastName), 1),
                              _createElementVNode("div", _hoisted_68, _toDisplayString(_ctx.accounts.adminUser.Email), 1)
                            ]))
                          : (_openBlock(), _createElementBlock("div", _hoisted_69, "Not linked"))
                      ]),
                      _createElementVNode("div", _hoisted_70, [
                        _cache[40] || (_cache[40] = _createElementVNode("div", { class: "emp-field-label" }, "Standard user", -1)),
                        (_ctx.accounts.publicUser)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_71, [
                              _createTextVNode(_toDisplayString(_ctx.accounts.publicUser.FirstName) + " " + _toDisplayString(_ctx.accounts.publicUser.LastName), 1),
                              _createElementVNode("div", _hoisted_72, _toDisplayString(_ctx.formatPhone(_ctx.accounts.publicUser.Phone)), 1)
                            ]))
                          : (_openBlock(), _createElementBlock("div", _hoisted_73, "Not linked"))
                      ]),
                      (_ctx.accounts.adminUser && _ctx.accounts.publicUser)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_74, "They can switch between Admin and Standard."))
                        : _createCommentVNode("", true)
                    ], 64))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createElementVNode("div", _hoisted_75, [
                        _cache[42] || (_cache[42] = _createElementVNode("label", {
                          class: "emp-field-label",
                          for: "emp-admin-account"
                        }, "Admin account", -1)),
                        _withDirectives(_createElementVNode("select", {
                          id: "emp-admin-account",
                          "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.accountsForm.UserID) = $event))
                        }, [
                          _cache[41] || (_cache[41] = _createElementVNode("option", { value: null }, "Not linked", -1)),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.adminChoices, (u) => {
                            return (_openBlock(), _createElementBlock("option", {
                              key: u.UserID,
                              value: u.UserID
                            }, _toDisplayString(u.FirstName) + " " + _toDisplayString(u.LastName) + " (" + _toDisplayString(u.Email) + ")", 9, _hoisted_76))
                          }), 128))
                        ], 512), [
                          [_vModelSelect, _ctx.accountsForm.UserID]
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_77, [
                        _cache[44] || (_cache[44] = _createElementVNode("label", {
                          class: "emp-field-label",
                          for: "emp-public-user"
                        }, "Standard user", -1)),
                        _withDirectives(_createElementVNode("select", {
                          id: "emp-public-user",
                          "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.accountsForm.PublicUserID) = $event))
                        }, [
                          _cache[43] || (_cache[43] = _createElementVNode("option", { value: null }, "Not linked", -1)),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.publicChoices, (p) => {
                            return (_openBlock(), _createElementBlock("option", {
                              key: p.ID,
                              value: p.ID
                            }, _toDisplayString(p.FirstName) + " " + _toDisplayString(p.LastName) + " (" + _toDisplayString(_ctx.formatPhone(p.Phone)) + ")", 9, _hoisted_78))
                          }), 128))
                        ], 512), [
                          [_vModelSelect, _ctx.accountsForm.PublicUserID]
                        ])
                      ]),
                      _cache[45] || (_cache[45] = _createElementVNode("div", { class: "emp-accounts-hint" }, "Only accounts that aren't linked to another employee are listed.", -1)),
                      _createElementVNode("div", {
                        class: _normalizeClass(_ctx.savingAccounts ? 'btn disable-button' : 'btn'),
                        onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.saveAccounts()))
                      }, "Save", 2)
                    ], 64))
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ], 2),
    (_ctx.showChecklist)
      ? (_openBlock(), _createBlock(_component_pdf_pop_up, {
          key: 0,
          url: `/playbook/${_ctx.checklistSlugToView}?hideNav=t&hideComponent=t&hideChat=t&fullChecklist=t`,
          onClose: _cache[14] || (_cache[14] = () => _ctx.showChecklist = false)
        }, null, 8, ["url"]))
      : _createCommentVNode("", true),
    (_ctx.showViewRole)
      ? (_openBlock(), _createBlock(_component_team_hub_role_col, {
          key: 1,
          onClose: _cache[15] || (_cache[15] = () => { _ctx.showViewRole = false }),
          slug: _ctx.rawEmployee.RoleSheetSlug,
          colID: _ctx.rawEmployee.RoleSheetColID
        }, null, 8, ["slug", "colID"]))
      : _createCommentVNode("", true),
    (_ctx.showAddEdit)
      ? (_openBlock(), _createBlock(_component_add_edit_employee, {
          key: 2,
          employeeToEdit: _ctx.rawEmployee,
          onClose: _cache[16] || (_cache[16] = () => { _ctx.showAddEdit = false; _ctx.loadEmployee(); })
        }, null, 8, ["employeeToEdit"]))
      : _createCommentVNode("", true),
    (_ctx.showReview)
      ? (_openBlock(), _createBlock(_component_add_employee_review, {
          key: 3,
          employee: _ctx.formData,
          employeeReviewFields: _ctx.employeeReviewFields,
          onClose: _cache[17] || (_cache[17] = () => { _ctx.showReview = false; _ctx.loadEmployee(); })
        }, null, 8, ["employee", "employeeReviewFields"]))
      : _createCommentVNode("", true),
    (_ctx.showEditChecklists)
      ? (_openBlock(), _createBlock(_component_edit_employee_checklists, {
          key: 4,
          employeeToEdit: _ctx.rawEmployee,
          onClose: _cache[18] || (_cache[18] = () => { _ctx.showEditChecklists = false; _ctx.loadEmployee(); })
        }, null, 8, ["employeeToEdit"]))
      : _createCommentVNode("", true),
    (_ctx.showEditRole)
      ? (_openBlock(), _createBlock(_component_edit_employee_role, {
          key: 5,
          employeeToEdit: _ctx.rawEmployee,
          onClose: _cache[19] || (_cache[19] = () => { _ctx.showEditRole = false; _ctx.loadEmployee(); })
        }, null, 8, ["employeeToEdit"]))
      : _createCommentVNode("", true)
  ]))
}